export default {
  'routeDetails': {
    'routeDetails': 'Détails de l\'itinéraire',
    'warnings': 'Mises en garde',
    'routes': 'Itinéraires',
    'route': 'Itinéraire',
    'segments': 'Segments',
    'segment': 'Segment',
    'instructions': 'Instructions',
    'instruction': 'Instruction',
    'name': 'Nom',
    'selectRoute': 'Sélectionnez cet itinéraire',
    'selectedRoute': 'Itinéraire sélectionné',
    'gotoSegment': 'Aller au segment',
    'warningCodes': {
      '1': 'Il peut y avoir des restrictions sur certaines routes',
      '2': 'Il y a des péages le long de l\'itinéraire',
      '3': 'Il y a des segments ignorés le long de l\'itinéraire. Les durées et l\'accessibilité peuvent ne pas être correctes',
      '4': 'Au moins une information supplémentaire demandée mais non disponible'
    },
    'routeOpacity': 'Opacité de l\'itinéraire'
  }
}
